<twc-drawer caption="{{'EXPRESSION_EDITOR.TITLE' | translate}}" position="right">
    <twc-drawer-content>
        <h4>{{'EXPRESSION_EDITOR.INTRO_TEXT' | translate}}</h4>

        <div class="expression-radio-group">
            <twc-radio>
                <label twcRadioLabel>{{'EXPRESSION_EDITOR.ALWAYS_TRUE' |
                    translate}}</label>
                <input twcRadioInput type="radio" [(ngModel)]="expressionState.exprType" name="expressionType"
                    value="EXPRESSION_EDITOR.ALWAYS_TRUE" (input)="setAlwaysTrue()">
            </twc-radio>

            <twc-radio>
                <label twcRadioLabel>{{'EXPRESSION_EDITOR.PREDEFINED' | translate}}</label>
                <input twcRadioInput (input)="setPredefined()" type="radio" [(ngModel)]="expressionState.exprType"
                    name="expressionType" value="EXPRESSION_EDITOR.PREDEFINED">
            </twc-radio>

            <!-- PREDEFINED EXPRESSION -->
            <div *ngIf="isPredefined()" class="twc-mb-3">
                <div class="expression-row  twc-mb-2 twc-mt-2">
                    <twc-select [(ngModel)]="expressionState.field" (ngModelChange)="setPredefined()"
                        aria-label="expressionState.field" class="field-name">
                        <twc-select-option *ngFor="let fieldItem of expressionState.fieldsExpression"
                            [value]="fieldItem.id">
                            {{translateByField(fieldItem.id)}}
                        </twc-select-option>
                    </twc-select>

                    <twc-select class="twc-ml-2 twc-mr-2" [(ngModel)]="expressionState.op1"
                        twcTooltip="{{getTip(expressionState.op1) | translate}}" (ngModelChange)="setPredefined()"
                        aria-label="expressionState.op1">
                        <twc-select-option *ngFor="let op of expressionState.operators" [value]="op.symbol">
                            {{op.symbol}}
                        </twc-select-option>
                    </twc-select>

                    <input (input)="setPredefined()" [(ngModel)]="expressionState.value1" [pattern]="getInputPattern()"
                        class="twc-input" aria-label="expressionState.value1">

                </div>

                <twc-toggle class="twc-mt-2 twc-mb-1">
                    <label twcToggleLabel>{{'EXPRESSION_EDITOR.AND' | translate}}
                    </label>
                    <input twcToggleInput [(ngModel)]="expressionState.useAnd" (change)="setPredefined()"
                        type="checkbox" aria-label="EXPRESSION_EDITOR.AND">
                </twc-toggle>

                <div class="expression-row twc-mb-2 twc-mt-2" *ngIf="expressionState.useAnd && isPredefined">
                    <span class="field-name twc-pl-3 twc-mb-2 twc-body">{{ translateByField(expressionState.field)
                        }}</span>
                    <twc-select class="twc-ml-2 twc-mr-2" [(ngModel)]="expressionState.op2"
                        twcTooltip="{{getTip(expressionState.op2) | translate}}" (ngModelChange)="setPredefined()"
                        aria-label="expressionState.op2">
                        <twc-select-option *ngFor="let op of getVisibleOperators()" [value]="op.symbol">
                            {{op.symbol}}
                        </twc-select-option>
                    </twc-select>

                    <input (input)="setPredefined()" [(ngModel)]="expressionState.value2" [pattern]="getInputPattern()"
                        class="twc-input" aria-label="expressionState.value2">

                </div>

                <p class="twc-mb-2">
                    {{'EXPRESSION_EDITOR.RESULT' | translate}}
                </p>
                <textarea class="twc-textarea predefined twc-mt-2" [(ngModel)]="expressionState.customExpr"
                    [ngClass]="{'twc-invalid': !expressionState.isValid}" rows="1" disabled></textarea>


            </div>

            <twc-radio>
                <label twcRadioLabel>{{'EXPRESSION_EDITOR.CUSTOM' | translate}}</label>
                <input twcRadioInput (input)="setCustom()" type="radio" [(ngModel)]="expressionState.exprType"
                    name="expressionType" value="EXPRESSION_EDITOR.CUSTOM">
            </twc-radio>

            <div class="twc-mb-3">
                <!-- CUSTOM EXPRESSION -->
                <ng-container *ngIf="isCustom()">
                    <p class="twc-mb-2 twc-body">{{'EXPRESSION_EDITOR.CUSTOM_INSTRUCTION_1' | translate}}</p>
                    <p class="twc-mb-2 twc-body">{{'EXPRESSION_EDITOR.CUSTOM_INSTRUCTION_2' | translate}}</p>
                    <p class="twc-mb-2 twc-body">{{'EXPRESSION_EDITOR.CUSTOM_INSTRUCTION_3' | translate}}</p>
                    <p class="twc-mb-2 twc-body">{{'EXPRESSION_EDITOR.CUSTOM_INSTRUCTION_4' | translate}}</p>

                    <textarea class="twc-textarea twc-mt-2" [(ngModel)]="expressionState.customExpr"
                        [ngClass]="{'twc-invalid': !expressionState.isValid}" rows="1" (input)="setCustom()"></textarea>

                </ng-container>
            </div>

        </div>

    </twc-drawer-content>
</twc-drawer>